import type { AuditLogsResponse, OwnerAuditLogsRequest, ProjectAuditLogsRequest } from '@/app/pages/AuditLogs/types'
import type { AuditLogsParams } from '@/types/organization-owner-api'
import { demoApi } from './db'

export const auditLogsApi = {
	getOrganizationAuditLogs: async (
		organizationId: string,
		params: AuditLogsParams | OwnerAuditLogsRequest,
	): Promise<{ count: number; data: AuditLogsResponse['data'] }> => {
		const body = {
			...params,
		}
		return demoApi.postNoTenant<{ count: number; data: AuditLogsResponse['data'] }>(
			`/organizations/${organizationId}/audit-logs`,
			body,
		)
	},
	getProjectAuditLogs: async (params: ProjectAuditLogsRequest): Promise<AuditLogsResponse> =>
		demoApi.post<AuditLogsResponse>('/audit-logs', params),
}
